// extracted by mini-css-extract-plugin
export default {"button_click":"ButtonClick_button_click__OHbQ1","button_click_animate":"ButtonClick_button_click_animate__OiceV"};